import { FormControlLabel, Switch } from '@mui/material';
import { FC } from 'react';

type Props = {
  checked: boolean;
  onChange: () => void;
  label?: string;
};

const NotifyMailroomSwitch: FC<Props> = ({
  checked,
  onChange,
  label = 'Notify mailroom users about pending request',
}) => <FormControlLabel control={<Switch />} checked={checked} onChange={onChange} label={label} />;

export default NotifyMailroomSwitch;
